import {Http} from '../../../Data/config/Http';
import {API_ROUTES} from '../../../constants/apiRoutes';
import type {BaseResponse} from '../../../Data/types/BaseResponse';
import {unwrapResponse, handleDataSourceError} from '../../../utils/errorHelpers';

export interface CreditProfileDTO {
  store_id: number;
  store_name?: string;
  credit_limit: number;
  used_credit: number;
  available_credit: number;
  credit_utilization: number;
  payment_rating?: 'A'|'B'|'C'|'D';
  can_sell_on_credit?: boolean;
}

export const CreditDashboardAPIDataSource = {
  async getAvailableCredit (storeId: number | string): Promise<BaseResponse<CreditProfileDTO>> {
    try {
      const response = await Http.get<BaseResponse<CreditProfileDTO>>(API_ROUTES.CREDIT.AVAILABLE_CREDIT(storeId));
      unwrapResponse(response.data, 'حدث خطأ في جلب الائتمان المتاح');
      return response.data;
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  async checkCreditEligibility (storeId: number | string, amount: number): Promise<BaseResponse<any>> {
    try {
      const response = await Http.post<BaseResponse<any>>(API_ROUTES.CREDIT.CREDIT_ELIGIBILITY(storeId), {amount});
      unwrapResponse(response.data, 'حدث خطأ في التحقق من أهلية الائتمان');
      return response.data;
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  async updatePaymentRating (storeId: number | string, newRating: 'A'|'B'|'C'|'D'): Promise<BaseResponse<any>> {
    try {
      const response = await Http.post<BaseResponse<any>>(API_ROUTES.CREDIT.UPDATE_RATING(storeId), {rating: newRating});
      unwrapResponse(response.data, 'حدث خطأ في تحديث تصنيف الدفع');
      return response.data;
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  async updateCreditLimit (
    storeId: number | string,
    payload: { credit_limit: number; reason?: string }
  ): Promise<any> {
    try {
      const response = await Http.put<BaseResponse<any>>(
        API_ROUTES.CREDIT.UPDATE_CREDIT_LIMIT(storeId),
        payload
      );
      return unwrapResponse(response.data, 'حدث خطأ أثناء تحديث حد الائتمان');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  async getCreditReport (storeId: number | string): Promise<BaseResponse<any>> {
    try {
      const response = await Http.get<BaseResponse<any>>(API_ROUTES.CREDIT.CREDIT_REPORT(storeId));
      unwrapResponse(response.data, 'حدث خطأ في جلب تقرير الائتمان');
      return response.data;
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  async getAllCreditReports (params: {page?: number; limit?: number; search?: string}): Promise<BaseResponse<any>> {
    try {
      const response = await Http.get<BaseResponse<any>>(API_ROUTES.CREDIT.CREDIT_REPORTS, {params});
      unwrapResponse(response.data, 'حدث خطأ في جلب تقارير الائتمان');
      return response.data;
    } catch (error) {
      handleDataSourceError(error);
    }
  }
};


